export const environment = {
  production: true,
  hmr: false,
  ENVNAME: 'production',
  IDENTITY: JSON.stringify('/'),
  CJHUB: JSON.stringify('/'),
  PARKIFLY_FLYGETS_PATH: "/parkifly/flygets/booking",

  PARKING_DISPLAY: JSON.stringify('https://parking-display-test.mangocliff-b7a35cda.swedencentral.azurecontainerapps.io/'),

  mapbox: {
    accessToken:
      'pk.eyJ1IjoibW9sbmRyaWZ0IiwiYSI6ImNram9hbG0yczJrOWgyenFvYmhpZWtna2UifQ.RDUPgFliWdqFBJwT_x9uGw'
  },
  appInsights: {
    instrumentationKey: '2eeaa521-ddc8-4ca3-9a7e-9a886bb7f1fe'
  }
};
